export const playwright_notification_success = "notification.success";
export const playwright_notification_info = "notification.info";
export const playwright_notification_error = "notification.error";
